import "core-js/modules/es.object.values.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import { createSelector } from 'reselect';
// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

var studentApplicationsSelector = function studentApplicationsSelector(store) {
  return store.studentApplications;
};
var invoiceSidebar = function invoiceSidebar(store) {
  return store.invoiceSidebar;
};
export var studentApplications = createSelector(studentApplicationsSelector, function (root) {
  return root && root.applications ? Object.values(root.applications) : [];
});
export var isStudentApplicationsLoaded = createSelector(studentApplicationsSelector, function (root) {
  return root.isLoaded;
});
export var studentApplicationsErrors = createSelector(studentApplicationsSelector, function (root) {
  return root.errors;
});
export var invoicePanelId = createSelector(invoiceSidebar, function (sidebar) {
  return sidebar.id;
});
export var selectedApplications = createSelector(studentApplicationsSelector, function (root) {
  return root.selectedApplications;
});

// General Selectors

export var programName = function programName(application) {
  return application && application.program && application.program.name || '';
};
export var programLink = function programLink(application) {
  return application && application.program && application.program.link || null;
};
export var schoolName = function schoolName(application) {
  return application && application.school && application.school.name || '';
};
export var schoolLink = function schoolLink(application) {
  return application && application.school && application.school.link || null;
};
export var schoolLogo = function schoolLogo(application) {
  return application && application.school && application.school.logo_url || null;
};
export var status = function status(application) {
  return (application === null || application === void 0 ? void 0 : application.status) || null;
};
export var isPaid = function isPaid(application) {
  return application && application.paid;
};
export var verificationPending = function verificationPending(application) {
  return application && application.payment_verification_pending;
};
export var isConditional = function isConditional(application) {
  return application && application.admission_type === 'Conditional';
};
export var intake = function intake(application) {
  return application && application.intake;
};
export var intakeEsl = function intakeEsl(application) {
  return application && application.intake_esl;
};
export var programActualStartDate = function programActualStartDate(application) {
  return application && application.program_actual_start_date;
};
export var eslActualStartDate = function eslActualStartDate(application) {
  return application && application.esl_actual_start_date;
};
export var programAlternateActualStartDate = function programAlternateActualStartDate(application) {
  return application && application.program_alternate_actual_start_date;
};
export var eslAlternateActualStartDate = function eslAlternateActualStartDate(application) {
  return application && application.esl_alternate_actual_start_date;
};
export var initialActualStartDate = function initialActualStartDate(application) {
  return application && application.initialActualStartDate;
};
export var intakeOptions = function intakeOptions(application) {
  return application && application.program && application.program.intakes;
};
export var intakeEslOptions = function intakeEslOptions(application) {
  return application && application.program_esl && application.program_esl.intakes;
};
export var appId = function appId(application) {
  return application && application.id;
};
export var appLink = function appLink(application) {
  return application && application.link;
};
export var requirementsStatus = function requirementsStatus(application) {
  return application && application.meta && application.meta.requirements_status || {};
};
export var requirementsLink = function requirementsLink(application) {
  return application && application.meta && application.meta.requirements_status && application.meta.requirements_status.link || null;
};
export var currentStage = function currentStage(application) {
  return application && application.meta && application.meta.current_stage.display_name || 'Pre-Submission';
};
export var isPrePayment = function isPrePayment(application) {
  return application && application.meta && application.meta.current_stage.name || 'pre-payment';
};
export var notesInfo = function notesInfo(application) {
  return application && application.meta && application.meta.notes || {};
};
export var applicationOncePerStudentCharges = function applicationOncePerStudentCharges(application) {
  return application && application.service_charges && application.service_charges.filter(function (sc) {
    return sc.charge_type === 'per_student';
  }) || [];
};
export var hasOncePerStudentCharge = function hasOncePerStudentCharge(application) {
  return application && application.service_charges && !application.paid && !application.payment_verification_pending && application.service_charges.some(function (sc) {
    return sc.charge_type === 'per_student';
  }) || false;
};